import { Button, Grid, IconButton, InputBase, LinearProgress, Modal, Paper } from '@material-ui/core';
import TagIcon from '@material-ui/icons/LocalOffer';
import React, { useEffect, useState } from "react";
import Gallery from "react-photo-gallery";
import { useParams } from "react-router-dom";
import { IMG_URL } from '../../config/config';
import { useDispatch, useSelector } from '../../store';
import { useDebounce } from '../../hooks/useDebounce';
import { shuffleSeed } from '../../libs/functions';
import { loadCode, saveCode } from '../../storage';
import Loader from '../Loader/Loader';
import BigImage from './BigImage';
import { getSearch, postUpdates, postLikes } from './Galeria.Api';
import './Galeria.scss';
import Login from './Login';
import SelectedImage from './SelectedImage';
// import { withSnackbar } from './SnackbarHOC';
import TitleBar from './TitleBar';

export const colors = {
	bg1: '#212121',
	bg2: '#414141',
	bg3: '#595959',
	bg4: '#757575',
	text: '#acacac',
	text2: '#fafafa',
	primary: '#425722',
}


function Galeria({ }) {
	const { section } = useParams();
	const apiCode = loadCode()


	const dispatch = useDispatch();
	const count = useSelector(state => state.count);

	async function fetchData() {
		const response = await fetch('https://api.example.com/data');
		const data = await response.json();
		dispatch({ data });
	}


	const items = useSelector(state => state.items);
	const isLoading = useSelector(state => state.isLoading);
	const isAdmin = useSelector(state => state.isAdmin);

	const currentItem = useSelector(state => state.currentItem);
	const viewerIsOpen = useSelector(state => state.viewerIsOpen);

	const rndSeed = useSelector(state => state.seed);

	const query = useSelector(state => state.query);
	const debouncedQuery = useDebounce(query, 500);



	useEffect(() => {
		//async effect trick
		if (apiCode) {
			dispatch({ isLoading: true })//setIsLoading(true)
			_fetchData();
		}
	}, [debouncedQuery, apiCode])


	async function _fetchData() {
		const res = await getSearch(debouncedQuery)
		dispatch({ isLoading: false });//setIsLoading(false);
		if (res) {
			const rows = shuffleSeed(res?.rows, rndSeed)
			dispatch({
				items: rows,
				isAdmin: res.auth,
				cloud: res.cloud
			})//setItems(rows)
			// dispatch({  })//setIsAdmin(res.auth)
		}
	}

	const handleSelect = (e, picture, state) => {
		// only admins can select
		if (isAdmin) {
			const newItems = items.map(row => {
				if (row.url === picture.url) row.selected = !row.selected;
				return row
			})
			dispatch({ items: newItems })//setItems(newItems)
		}
	}


	const handleQueryUpdate = (newQuery) => {
		dispatch({ query: { ...query, ...newQuery } })//setQuery({ ...query, ...newQuery })
	}


	const handleTagClick = (tag) => {
		// console.log(`tag clicked`, tag)
		let newTags = query.tags ? [...query.tags] : []
		if (newTags.indexOf(tag) > -1) {
			//exists,remove
			newTags = newTags.filter(ttag => ttag !== tag)
		} else {
			//doesn't exist, add
			// console.log(`add`)
			newTags.push(tag)
			// console.log(`newTags`, newTags)
		}
		const newQuery = { ...query, tags: newTags };
		dispatch({ query: { ...query, ...newQuery } })//setQuery(newQuery);
	}


	const handleClick = (e, photo) => {
		const newPhoto = items.find(row => row.url === photo.url)
		if (newPhoto) {
			dispatch({
				currentItem: newPhoto,
				viewerIsOpen: true
			})
		}

	}

	const handleViewerClose = (e) => dispatch({ viewerIsOpen: false })//setViewerIsOpen(false)

	// const handleDeselectAll = (e) => {
	// 	const newItems = items.map(row => {
	// 		row.selected = false;
	// 		return row
	// 	})
	// 	dispatch({ items: newItems })//setItems(newItems)
	// }


	// const handleMarkNsfw = async e => {
	// 	// form the update 
	// 	const updates = items.filter(x => x.selected).map(r => {
	// 		return ({ "publicId": r.publicId, "nsfw": 1 })
	// 	})
	// 	await update(updates)
	// }



	async function update(payloads) {
		dispatch({ isLoading: true })//setIsLoading(true)
		const res = await postUpdates(payloads)
		dispatch({ isLoading: false })//setIsLoading(false)
		const newItems = await getSearch(query)
		dispatch({ items: newItems.rows })
		if (newItems?.rows && currentItem) {
			const it = newItems.rows.find(t => currentItem.publicId === t.publicId)
			if (it) {
				dispatch({ currentItem: { ...it } })
			}
		}
		if (newItems) {
			const rows = shuffleSeed(newItems.rows, rndSeed)
			dispatch({ items: rows })//setItems(newItems.rows)
		}
	}

	async function likeupdate(payloads) {
		dispatch({ isLoading: true })//setIsLoading(true)
		const res = await postLikes(payloads)
		dispatch({ isLoading: false })//setIsLoading(false)
		const newItems = await getSearch(query)
		dispatch({ items: newItems.rows })
		if (newItems?.rows && currentItem) {
			const it = newItems.rows.find(t => currentItem.publicId === t.publicId)
			if (it) {
				dispatch({ currentItem: { ...it } })
			}
		}
		if (newItems) {
			const rows = shuffleSeed(newItems.rows, rndSeed)
			dispatch({ items: rows })//setItems(newItems.rows)
		}
	}

	const handleOnLogout = () => {
		saveCode('')
		window.location.reload()// = '/pic'
	}


	//if not logged in, ignore everything else
	if (!apiCode) {
		return (<Login />)
	}

	const pics = items ? items.map(item => {
		let width = item.width ? item.width : 0;
		let height = item.height ? item.height : 0;


		if (item.width > item.height) {
			const ratio = item.width / item.height;
			height = 4;
			width = Math.ceil(height * ratio)
			// height = Math.ceil((mawidth / (width)) * height);
			// width=maxwidth;
		}

		return ({
			publicId: item.publicId,
			src: IMG_URL + '/raw/' + item.url,
			selected: item.selected,
			url: item.url,
			width: width,
			height: height,
			nsfw: item.nsfw,
			tags: item?.tags,
			name: item?.name,
			color: item?.color,
			thumbsUp: item.thumbsUp
		})
	}) : []

	const selectedItems = items ? items.filter(x => x.selected) : []
	// console.log(`pics`, pics)


	return (

		<div className="Galeria">

			<TitleBar
				// items={items}
				// query={query}
				// isAdmin={isAdmin}
				onUpdate={update}
				onQuery={handleQueryUpdate}
				onLogout={handleOnLogout}
				onTagClick={handleTagClick}
			/>
			{false && isLoading && <LinearProgress />}
			{isLoading && <Loader />}
			{/* <SortableGallery items={filteredItems} onSortEnd={onSortEnd} axis={"xy"} /> */}
			<Modal
				open={viewerIsOpen}
				onClose={handleViewerClose}
				aria-labelledby="simple-modal-title"
				aria-describedby="simple-modal-description"
			>
				{currentItem ? <BigImage
					isAdmin={isAdmin}
					// currentItem={currentItem}
					onViewerClose={handleViewerClose}
					// update={update}
					onUpdate={update}
					onLikeUpdate={likeupdate}
				/> : <div></div>}
			</Modal>
			<Grid container spacing={3}>
				<Grid item xs={12}>
					{true && <Gallery
						photos={pics}
						// onClick={handleClick}
						renderImage={({ index, left, top, key, photo }) => (
							<SelectedImage
								selected={!!photo.selected}
								onSelect={handleSelect}
								onClick={handleClick}
								key={key}
								margin={"2px"}
								index={index}
								photo={photo}
								left={left}
								top={top}
							/>
						)}
					/>}

				</Grid>
				{false && <Grid item xs={isAdmin ? 3 : 0}>
					<Paper className="Paper" style={{ position: 'sticky', top: '65px', padding: '1em' }}>
						{/* {true && <ImageDetailsEditor image={currentItem} isAdmin={isAdmin} />} */}
						{/* {(selectedItems.length > 0) && <AddTag onAdd={handleAddTag} />} */}
						{/* {(selectedItems.length > 0) && <Button onClick={handleDeselectAll}>Deselect all</Button>} */}

						{/* {true && (selectedItems.length > 0) && <Button onClick={handleMarkNsfw}>mark {selectedItems.length} selected items as nsfw</Button>} */}

					</Paper>
				</Grid>}
			</Grid>
		</div>

	);
}
// export default withSnackbar(Galeria);
export default Galeria;


const AddTag = ({ onAdd }) => {
	const [tag, setTag] = useState('')
	return (
		<Paper component="form">
			{/* <IconButton className={classes.iconButton} aria-label="menu">
          <MenuIcon />
        </IconButton> */}
			<table>
				<tbody>
					<tr>
						<td>
							<InputBase
								value={tag}
								onChange={e => setTag(e.target.value)}
								placeholder="add tag"
								inputProps={{ 'aria-label': 'search google maps' }}
								style={{ display: 'inline-block' }}
							/>
						</td>
						<td>
							<IconButton aria-label="search" onClick={e => onAdd(tag, e)}>
								<TagIcon />
							</IconButton>
						</td>
					</tr>
				</tbody>
			</table>


			{/* <Divider className={classes.divider} orientation="vertical" />
        <IconButton color="primary" className={classes.iconButton} aria-label="directions">
          <DirectionsIcon />
        </IconButton> */}
		</Paper>
	)
}




// const ImageDetailsEditor = ({ image, isAdmin }) => {
// 	// console.log(`image`, image)
// 	return (
// 		<div className='ImageDetails'>
// 			<div className='image-id'>{image.publicId}  {image.nsfw > 0 ? '[NSFW]' : ''}</div>
// 			<div className='image-name'>
// 				<input style={{ width: '100%', fontSize: '120%', lineHeight: '120%', fontWeight: 'bold' }} value={image.name} placeholder="image title" />
// 			</div>
// 			<div className='image-description'>
// 				<div><label>Description:</label></div>
// 				<textarea style={{ width: '100%', height: '150px' }} value={image.description} placeholder="description" />
// 			</div>
// 			<div className='image-tags'>
// 				<div><label>Tags:</label></div>
// 				<input style={{ width: '100%' }} value={image.tags} />
// 			</div>
// 			<div className='image-dates'>{image.createdAt}  {image.upatedAt} </div>
// 			{<div className='image-info'>
// 				<div><label>Technical info:</label></div>
// 				<textarea style={{ width: '100%', height: '150px' }} value={image.info} />
// 			</div>}

// 		</div>
// 	)
// }
